import React, { useEffect, useState } from 'react';
import style from './EventGameboard.scss.json';
import './EventGameboard.scss';
import { useTranslate } from '@tolgee/react';
import { InteractiveGlobe } from '../atoms/InteractiveGlobe';
import { asset } from 'lincd/lib/utils/LinkedFileStorage';
import { LocationTotals } from 'lincd-irlcg/lib/types/gameboard';
import { useAuth } from 'lincd-auth/lib/hooks/useAuth';
import { Player } from 'lincd-irlcg/lib/shapes/Player';

export const EventGameboard = ({
  totalScore,
  totalLocation,
}: {
  totalScore?;
  totalLocation: LocationTotals;
}) => {
  let { t } = useTranslate();
  const {user} = useAuth<Player>();

  return (
    <div className={style.titleContainer}>
      <div className={style.eventContainer}>
        <img
          className={style.gearIcon}
          src={asset('/images/rotary_calgary.png')}
          alt="Rotary Calgary logo"
        />

        {/* <div className={style.iconContainer}> */}
        {/* <img
          className={style.globeIcon}
          src={asset('/images/icons/GlobeIcon.svg')}
          alt="globe icon"
        />
        <img
          className={style.calendarIcon}
          src={asset('/images/icons/CalendarFavIcon.svg')}
          alt="calendar icon"
        /> */}
        {/* </div> */}
        <div className={style.peaceGameContainer}>
          <img
            src={asset('/images/poe_logo_clear@2x.png')}
            width="24px"
            height="24px"
            alt="globe"
          />
          <h3 className={style.peaceGame}>Peace Game</h3>
        </div>
      </div>

      <h1>{t('word.GlobalGameBoard', 'Peace Gameboard')}</h1>

      <div className={style.interactiveGlobe}>
        <InteractiveGlobe event={user?.currentTeam?.uri} />
      </div>

      <div className={style.statusContainer}>
        <div className={style.status}>
          <h2 className={style.title}>{totalScore?.totalPlayer || 0}</h2>
          <p>{t('word.Players', 'Players')}</p>
        </div>
        <div className={style.status}>
          <h2 className={style.title}>{totalScore?.totalActions || 0}</h2>
          <p>{t('word.peaceActions', 'Peace Actions')}</p>
        </div>
        <div className={style.status}>
          <h2 className={style.title}>{totalLocation?.city || 0}</h2>
          <p>{t('word.cities', 'Cities')}</p>
        </div>
        <div className={style.status}>
          <h2 className={style.title}>{totalLocation?.country || 0}</h2>
          <p>{t('word.countries', 'Countries')}</p>
        </div>
      </div>
    </div>
  );
};
